import { useState, useCallback } from 'react';

const useProductSelection = (products) => {
  const [selectedProducts, setSelectedProducts] = useState(new Set());

  const handleSelectAll = useCallback((checked) => {
    if (checked) {
      const allProductIds = new Set((products || []).map(product => product.id));
      setSelectedProducts(allProductIds);
    } else {
      setSelectedProducts(new Set());
    }
  }, [products]);

  const handleSelectProduct = useCallback((productId, checked) => {
    const newSelected = new Set(selectedProducts);
    if (checked) {
      newSelected.add(productId);
    } else {
      newSelected.delete(productId);
    }
    setSelectedProducts(newSelected);
  }, [selectedProducts]);

  const clearSelection = useCallback(() => {
    setSelectedProducts(new Set());
  }, []);

  const isAllSelected = (products || []).length > 0 && selectedProducts.size === (products || []).length;
  const isIndeterminate = selectedProducts.size > 0 && selectedProducts.size < (products || []).length;

  return {
    selectedProducts,
    handleSelectAll,
    handleSelectProduct,
    clearSelection,
    isAllSelected,
    isIndeterminate
  };
};

export default useProductSelection;
